<!------------------------------------------------------------------------------
  Copyright (c) 2018. keni <$email>

  This file stars.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  stars.vue can not be copied and/or distributed
  without the express permission of keni
  ----------------------------------------------------------------------------->

<!------------------------------------------------------------------------------
 File: stars 
 Created by keni.
 with: IntelliJ IDEA
 Date: 29/05/2018
 Time: 12:28
------------------------------------------------------------------------------->
<template>
    <div>
        <i v-for="heart in hearts" class="material-icons" aria-hidden="true">favorite</i>
    </div>
</template>

<script>
	export default {
		name: "stars",
		components: {},
		props: {
			value: Number,
			max: Number
		},
		created() {
		},
		destroyed() {
		},
		mounted() {
			if (typeof this.max !== 'undefined' && this.max !== null) {
				this.limit = this.max;
			}
			else {

			}
			this.createHearts()
		},
		data() {
			return {
				limit: 5,
				hearts: 0
			}
		},
		methods: {
			createHearts() {
				// let dissections = 100 / this.limit;
				if (typeof this.value != 'undefined' && this.value !== null) {
					this.hearts = Math.ceil((this.value / 2) / 10);

				}
			}
		},
		watch: {},
		computed: {}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/front/modules/stars.vue